/** Preserve customer context and other query parameters in old ticket links. */
export function legacyTicketRedirect(id: string | undefined, search: string): string {
  const params = new URLSearchParams(search);
  if (id) params.set('ticket', id);
  return `/agent?${params}`;
}
